<template>
	<div class="product-index">
		<FunctionTitle :title="mainTitle" />
		<CommonFlame :title="title">
			<template v-if="!$vuetify.breakpoint.xs" v-slot:app-bar-btn>
				<v-btn
					v-if="create_flg"
					color="primary"
					class="ml-2"
					@click="$router.push({ path: '/products/new' })"
				>
					<v-icon class="mr-1">mdi-plus</v-icon>
					製品追加
				</v-btn>
				<v-menu offset-y :close-on-content-click="false">
					<template v-slot:activator="{ on, attrs }">
						<v-btn color="primary" dark v-bind="attrs" v-on="on">
							<v-icon class="mr-2">mdi-magnify</v-icon>検索
						</v-btn>
					</template>
					<v-card width="300px">
						<v-app-bar dense color="primary" flat>
							<v-app-bar-title class="color-white text-body-1 font-weight-bold"
								>絞り込み検索</v-app-bar-title
							>
						</v-app-bar>
						<v-card-text class="pa-2">
							<v-form ref="form">
								<v-text-field
									v-model.trim="q.name_cont"
									label="製品名"
									class="mt-4"
									outlined
									dense
									hint="製品名を入力してください"
								></v-text-field>

								<v-select
									v-model.trim="q.product_code_prefix_id_eq"
									class="mt-4"
									required
									outlined
									dense
									:items="prefixes"
									item-text="name"
									item-value="id"
									label="品目接頭辞"
									clearable
									hint="品目接頭辞を選択してください"
								>
								</v-select>

								<v-text-field
									v-model.trim="q.product_code_cont"
									label="品目コード"
									class="mt-4"
									outlined
									dense
									hint="品目コードを入力してください"
								></v-text-field>

								<v-select
									v-model="q.status_eq"
									:items="statuses"
									clearable
									item-text="name"
									item-value="value"
									class="mt-4"
									label="ステータス"
									hint="ステータスを選択してください"
									dense
									outlined
								/>

								<v-row class="mt-4" no-gutters justify="center">
									<v-btn color="secondary" @click.prevent="search(1)" class="mr-2">
										<v-icon class="mr-2">mdi-magnify</v-icon>
										検索する</v-btn
									>
									<v-btn color="secondary" outlined @click="resetForm"> クリア</v-btn>
								</v-row>
							</v-form>
						</v-card-text>
					</v-card>
				</v-menu>
			</template>

			<template v-if="$vuetify.breakpoint.xs">
				<v-btn
					v-if="create_flg"
					color="secondary"
					class="ml-2"
					@click="$router.push({ path: '/products/new' })"
				>
					<v-icon class="mr-1">mdi-plus</v-icon>
					製品作成
				</v-btn>
				<v-divider class="mt-1"></v-divider>
				<v-row no-gutters :class="$vuetify.breakpoint.xs ? 'mt-2' : ''">
					<h3 class="text-h6 font-weight-bold">絞り込み検索</h3>
					<v-spacer />
					<v-switch
						color="primary"
						class="mt-0"
						v-model="showSearchForm"
						:label="showSearchForm ? 'フォームを隠す' : 'フォームを表示'"
						hide-details
					/>
				</v-row>

				<template>
					<v-sheet v-if="showSearchForm" elevation="0">
						<v-form ref="form">
							<v-text-field
								v-model.trim="q.name_cont"
								label="製品名"
								class="mt-2"
								outlined
								dense
								hint="製品名を入力してください"
								hide-details
							></v-text-field>

							<v-select
								v-model.trim="q.product_code_prefix_id_eq"
								class="mt-2"
								required
								outlined
								dense
								:items="prefixes"
								item-text="name"
								item-value="id"
								label="品目接頭辞"
								clearable
								hint="品目接頭辞を選択してください"
								hide-details
							>
							</v-select>

							<v-text-field
								v-model.trim="q.product_code_cont"
								label="品目コード"
								class="mt-2"
								outlined
								dense
								hint="品目コードを入力してください"
								hide-details
							></v-text-field>

							<v-row class="my-4" no-gutters justify="center">
								<v-btn @click.prevent="search(1)" class="mr-2" color="secondary">
									<v-icon class="mr-2">mdi-magnify</v-icon>
									検索する</v-btn
								>
								<v-btn @click="resetForm" color="secondary" outlined> クリア</v-btn>
							</v-row>
						</v-form>
					</v-sheet>
				</template>
			</template>

			<div class="table-container px-2">
				<v-data-table
					locale="ja-JP"
					:headers="headers"
					:items="products"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="データがありません。"
					@click:row="redirectTo"
				>
				</v-data-table>
				<PaginationModule :pagination="pagination" @get-page="getPage($event)"></PaginationModule>
			</div>
		</CommonFlame>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import rules from "../../helper/rules"
import Qs from "qs"
import PaginationModule from "../../modules/PaginationModule.vue"

import CommonFlame from "../shared/CommonFlame.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"

export default {
	components: {
		CommonFlame,
		FunctionTitle,
		PaginationModule,
	},
	data() {
		return {
			mainTitle: "製品",
			title: "製品一覧",
			rules,
			name: "",
			product_code: "",
			products: [],
			product: "",
			prefixes: [],
			create_flg: false,
			showSearchForm: true,
			statuses: [],
			q: {
				name_cont: "",
				product_code_cont: "",
				product_code_prefix_id_eq: "",
				status_eq: "",
			},
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			headers: [
				{ text: "製品名", width: "200px", value: "name" },
				{ text: "製品番号", width: "200px", value: "product_code" },
				{ text: "カテゴリー", width: "150px", value: "product_category.name" },
				{ text: "サブカテゴリー", width: "150px", value: "product_sub_category.name" },
				{ text: "原価", width: "150px", value: "cost_price" },
				{ text: "定価", width: "150px", value: "list_price" },
				{ text: "通常販売額", width: "150px", value: "standard_price" },
				{ text: "ステータス", width: "150px", value: "status_ja" },
			],
		}
	},
	mounted() {
		this.search(1)
	},
	methods: {
		search(page) {
			const headers = authenticate.setHeader()
			const params = { q: this.q, page }
			const paramsSerializer = (params) => Qs.stringify(params, { arrayFormat: "brackets" })
			axios
				.get(`/erp/v1/products`, { params, paramsSerializer, headers })
				.then((res) => {
					this.create_flg = res.data.create_flg
					this.prefixes = res.data.prefixes
					this.products = res.data.products
					this.statuses = res.data.statuses
					this.pagination = res.data.pagination
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		getPage(page) {
			this.search(page)
		},
		resetForm() {
			this.$refs.form.reset()
		},
		redirectTo(item) {
			this.$router.push({ name: "product_show", params: { id: item.id } })
		},
	},
}
</script>
